import script from "./CareerCompassResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerCompassResult.vue?vue&type=script&setup=true&lang=ts"

import "./CareerCompassResult.vue?vue&type=style&index=0&id=0fa3164a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa3164a"]])

export default __exports__